export {default as default} from './VideoDetailsContainer';


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/VideoDetails/index.ts